<template>
    <!-- <div class="flex-center" style="height: 50vh">
        <div>
            <h3 class="mb-3">Please login</h3>
            <div class="flex-center">
                <Button @onClick="login">
                    <span class="white--text">Login</span>
                </Button>
            </div>
        </div>
    </div> -->
    <div>
        <div v-if="isModalOpen" class="modal">
            <v-dialog v-model="dialogVisible" persistent max-width="325">
                <div class="modal-content">
                    <div style="margin: 24px 0;">
                        <div class="modal-title">Please login</div>
                        <!-- <div class="modal-detail">The locker will open after you confirm this locker.</div> -->
                    </div>
                    <div class="group-btn">
                        <button @click="login" class="confirm-btn">Login</button>
                    </div>
                </div>
            </v-dialog>
        </div>
    </div>
</template>

<script>
import Button from "../components/Button.vue"

export default {
    components: {
        Button,
    },
    data() {
        return {
            userId: null,
            isModalOpen: true,
            dialogVisible: true,
        }
    },
    methods: {
        login() {
            this.$router.push({ name: 'Landing' })
        },
        async fetchData() {
            this.userId = localStorage.getItem('user_id');
        },
    },
    created() {
        this.fetchData();
    },
}
</script>

<style scoped>
.modal-content {
    background-color: #fff;
    width: 325px;
    padding: 20px 24px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.modal-title {
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 12px;
}

.modal-detail {
    font-size: 14px;
    color: #C1C1C1;
}

.group-btn {
    display: flex;
    width: 100%;
}

.confirm-btn {
    font-size: 16px;
    padding: 8px 16px;
    color: #fff;
    background: linear-gradient(50deg, #FE9900 38.93%, #FFCD82 97.25%);
    border-radius: 8px;
    width: 100%;
}
</style>